import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import defined from '~app/core/defined';

const ErrorScreen = ({error}) => (
  <div className="ErrorScreen">
    <div className="ErrorScreen__content">
      <span className="ErrorScreen__title">
        An unrecoverable error has occured. Please try reloading the page.
      </span>
      <span className="ErrorScreen__message">
        {error.message}
      </span>
    </div>
  </div>
);

ErrorScreen.propTypes = {
  error: PropTypes.object.isRequired,
};

export { ErrorScreen };

const ErrorHandler = ({error, children}) => {
  if (defined(error)) return (
    <ErrorScreen error={error} />
  );
  return React.Children.only(children);
};

ErrorHandler.propTypes = {
  error: PropTypes.object,
  children: PropTypes.element.isRequired,
};

export { ErrorHandler };

const mapStateToProps = (state) => ({
  error: state.error.error,
});

export default connect(mapStateToProps)(ErrorHandler);



// WEBPACK FOOTER //
// ./src/components/ErrorHandler.js